import Modal from "react-bootstrap/Modal";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setAutoLabel,
  setBaseNote,
  setLabels,
  setPianoLabels,
  setUserSelectedLabels,
} from "../../store/actions";
import { changeLabels } from "../../helpers/pianoHelpers";

class LabelsModal extends Component {
  state = {
    scales: [
      // "{ A } { C, C♯, D, D♯, E, F, F♯, G, G♯, A, A♯, B }",
      // "{ B } { B♯, C♯, D, D♯, E, E♯, F♯, G, G♯, A, A♯, B }",
      // "{ C } { C, C♯, D, E♭, E, F, F♯, G, A♭, A, B♭, B }",
      // "{ D } { C, C♯, D, D♯, E, F, F♯, G, G♯, A, B♭, B }",
      // "{ E } { C, C♯, D, D♯, E, E♯, F♯, G, G♯, A, A♯, B }",
      // "{ F } { C, D♭, D, E♭, E, F, F♯, G, A♭, A, B♭, B }",
      // "{ G } { C, C♯, D, E♭, E, F, F♯, G, G♯, A, B♭, B }",
      // "{ A♭/G♯ } { C, D♭, D, E♭, F♭, F, G♭, G, A♭, A, B♭, B }",
      // "{ B♭ } { C, D♭, D, E♭, E, F, G♭, G, A♭, A, B♭, B }",
      // "{ D♭/C♯ } { C, D♭, D, E♭, E, F, G♭, G, A♭, B♭♭, B♭, C♭ }",
      // "{ E♭ } { C, D♭, D, E♭, E, F, G♭, G, A♭, A, B♭, C♭ }",
      // "{ F♯ } { B♯, C♯, D, D♯, E, E♯, F♯, FX, G♯, A, A♯, B }",
      "{ A } { A, A♯, B, C, C♯, D, D♯, E, F, F♯, G, G♯ }",
      "{ B } { A, A♯, B, B♯, C♯, D, D♯, E, E♯, F♯, G, G♯ }",
      "{ C } { A, B♭, B, C, C♯, D, E♭, E, F, F♯, G, A♭ }",
      "{ D } { A, B♭, B, C, C♯, D, D♯, E, F, F♯, G, G♯ }",
      "{ E } { A, A♯, B, C, C♯, D, D♯, E, E♯, F♯, G, G♯ }",
      "{ F } { A, B♭, B, C, D♭, D, E♭, E, F, F♯, G, A♭ }",
      "{ G } { A, B♭, B, C, C♯, D, E♭, E, F, F♯, G, G♯ }",
      "{ A♭/G♯ } { A, B♭, C♭, C, D♭, D, E♭, F♭, F, G♭, G, A♭ }",
      "{ B♭ } { A, B♭, B, C, D♭, D, E♭, E, F, G♭, G, A♭ }",
      "{ D♭/C♯ } { B𝄫, B♭, C♭, C, D♭, D, E♭, F♭, F, G♭, G, A♭ }",
      "{ E♭ } { A, B♭, C♭, C, D♭, D, E♭, E, F, G♭, G, A♭ }",
      "{ F♯ } { A, A♯, B, B♯, C♯, D, D♯, E, E♯, F♯, G, G♯ }",
      "No Labels",
    ],
  };

  handleLabelChange = (e) => {
    e.preventDefault();
    this.props.setAutoLabel(false);
    this.props.setUserSelectedLabels(true);
    // Remove any hidden labels before applying changes
    changeLabels(
      this.props.selectedLabel,
      this.props.setPianoLabels,
      this.props.tonesMT,
      this.props.setBaseNote
    );

    // Close modal after applying changes
    this.props.toggleModal();
  };

  render() {
    return (
      <div>
        <Modal
          size="lg"
          show={this.props.show}
          onHide={this.props.toggleModal}
          aria-labelledby="vocal-range-popup"
        >
          <Modal.Header closeButton>
            <Modal.Title id="vocal-range-popup">
              Set Music Theory On Piano
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <div className="col-9 settings-group">
                  <div className="row">
                    <div className="form-group col-12 mb-2">
                      <label className="form-label" htmlFor="modesOfScales">
                        Select Labels
                      </label>
                      <select
                        id="modesOfScales"
                        className="form-control form-control-lg custom-select"
                        value={this.props.selectedLabel}
                        onChange={(e) => this.props.setLabels(e.target.value)}
                      >
                        {this.state.scales.map((item) => (
                          <option
                            className="custom-option"
                            value={item}
                            key={item}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <button
                className="btn btn_primary btn-lg"
                onClick={this.handleLabelChange}
              >
                Apply Changes
              </button>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tonesMT: state.tonesMT,
  NOTES: state.notes,
  selectedLabel: state.selectedLabel,
});

const mapDispatchToProps = {
  setPianoLabels,
  setLabels,
  setAutoLabel,
  setUserSelectedLabels,
  setBaseNote,
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelsModal);
